export const GET_BUILDING = (id: string): string => `query {
    building(id: "${id}") {
      ...on BuildingOutput {
        name
        llc
        fullAddress {
          label
          municipality
          postalCode
          street
          region
        }
        landlord {
          email
          name
          company
        }
      }
      ...on ErrorListOutput {
        errors{
          type
          message
        }
      }
    }
  }
`;
